import { estadosService } from "@/_services";

export const estados = {
  namespaced: true,
  state: {
    delete: {
      data: null,
      status: {},
    },
    list: {
      data: [],
      status: {},
    },
    saveEstado: {
      data: {},
      status: {},
    },
    estado: {
      data: {},
      status: {},
    },
    update: {
      data: {},
      status: {},
    },
    excel: {
      data: {},
      status: {},
    },
  },
  mutations: {
    deleteEstadoRequest(state) {
      state.delete.data = null;
      state.delete.status = { deleting: true };
    },
    deleteEstadoSuccess(state, response) {
      state.delete.data = response;
      state.delete.status = { deleted: true };
    },
    deleteEstadoError(state, error) {
      state.delete.data = null;
      state.delete.status = { error };
    },
    getEstadosRequest(state) {
      state.list.status = {
        loading: true,
      };
    },
    getEstadosError(state, error) {
      state.list.data = [];
      state.list.status = {
        error,
      };
    },
    getEstadosSuccess(state, estados) {
      state.list.data = estados;
      state.list.status = {
        loaded: true,
      };
    },
    saveEstadoRequest(state) {
      state.saveEstado.status = {
        loading: true,
      };
    },
    saveEstadoError(state, error) {
      state.saveEstado.data = [];
      state.saveEstado.status = {
        error,
      };
    },
    saveEstadoSuccess(state, estado) {
      state.saveEstado.data = estado;
      state.saveEstado.status = {
        loaded: true,
      };
    },
    getEstadoByIdRequest(state) {
      state.estado.status = {
        loading: true,
      };
    },
    getEstadoByIdError(state, error) {
      state.estado.data = {};
      state.estado.status = {
        error,
      };
    },
    getEstadoByIdSuccess(state, estado) {
      state.estado.data = estado;
      state.estado.status = {
        loaded: true,
      };
    },
    updateEstadoRequest(state) {
      state.update.status = {
        loading: true,
      };
    },
    updateEstadoError(state, error) {
      state.update.data = {};
      state.update.status = {
        error,
      };
    },
    updateEstadoSuccess(state, estado) {
      state.update.data = estado;
      state.update.status = {
        loaded: true,
      };
    },
    getEstadosExcelRequest(state) {
      state.excel.status = {
        downloading: true,
      };
    },
    getEstadosExcelError(state, error) {
      state.excel.data = {};
      state.excel.status = {
        error,
      };
    },
    getEstadosExcelSuccess(state, excel) {
      state.excel.data = excel;
      state.excel.status = {
        downloaded: true,
      };
    },
  },
  actions: {
    deleteEstado({ state, commit }, id) {
      if (state.delete.status.deleting) return;
      commit("deleteEstadoRequest");
      return estadosService.deleteEstado(id)
        .then((response) => {
          commit("deleteEstadoSuccess", response);
        })
        .catch((error) => {
          commit("deleteEstadoError", error);
        });
    },
    getEstados({ commit }, req) {
      commit("getEstadosRequest");
      estadosService
        .getEstados(req.pagination, req.filters)
        .then((estados) => {
          commit("getEstadosSuccess", estados);
        })
        .catch((error) => {
          commit("getEstadosError", error);
        });
    },
    saveEstado({ commit }, body) {
      commit("saveEstadoRequest");
      estadosService
        .saveEstado(body)
        .then((estados) => {
          commit("saveEstadoSuccess", estados);
        })
        .catch((error) => {
          commit("saveEstadoError", error);
        });
    },
    getEstadoById({ commit }, id) {
      commit("getEstadoByIdRequest");
      estadosService
        .getEstadoById(id)
        .then((estado) => {
          commit("getEstadoByIdSuccess", estado);
        })
        .catch((error) => {
          commit("getEstadoByIdError", error);
        });
    },
    updateEstado({ commit }, body) {
      commit("updateEstadoRequest");
      estadosService
        .updateEstado(body)
        .then((estado) => {
          commit("updateEstadoSuccess", estado);
        })
        .catch((error) => {
          commit("updateEstadoError", error);
        });
    },
    getEstadosExcel({ commit }, filters) {
      commit("getEstadosExcelRequest");
      estadosService
        .getEstadosExcel(filters)
        .then((estado) => {
          commit("getEstadosExcelSuccess", estado);
        })
        .catch((error) => {
          commit("getEstadosExcelError", error);
        });
    },
  },
};
